const getSitenav = document.querySelector('.post-template  .site-nav-main');


document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener('scroll', function () {
      // Calculate 10% of the page height
      const tenPercentOfPage = window.innerHeight * 0.1;

      // Check if the scroll position is greater than or equal to 10%
      if (window.scrollY >= tenPercentOfPage) {
          // Add the 'nav-post-title-active' class to getSitenav
          getSitenav.classList.add('nav-post-title-active');
      } else {
          // Remove the 'nav-post-title-active' class if scroll position is less than 10%
          getSitenav.classList.remove('nav-post-title-active');
      }
  });
});